import React from "react";

const META = {
  DRAFT: { label: "Draft", tone: "amber" },
  ACTIVE: { label: "Active", tone: "green" },
  ARCHIVED: { label: "Archived", tone: "gray" },
};

const TemplateStatusBadge = ({ status }) => {
  const meta = META[status] || { label: status || "—", tone: "gray" };
  return (
    <span className={`status-pill status-pill--${meta.tone}`}>
      {meta.label}
    </span>
  );
};

export default TemplateStatusBadge;
